export const convertFeet = (num,showInch) => {
    let feet = 0;
    let inch = 0;
    let str = '';
    feet = Math.floor(num);
    inch = Math.floor(((num - feet) * 12));
    if (feet === 0) {
        if (inch !== 0) {
            str = `${inch}"`;
        } else {
            str = '0"';
        }
    } else {
        if (inch !== 0) {
            if(showInch == false){
                str = `${feet}'`;
            }else{
                str = `${feet}'${inch}"`;
            }
        } else {
            str = `${feet}'`;
        }        
    }

    return str;
}